import { render, staticRenderFns } from "./SchedulingCommonSetup.vue?vue&type=template&id=08c61aa4&scoped=true&"
import script from "./SchedulingCommonSetup.vue?vue&type=script&lang=js&"
export * from "./SchedulingCommonSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c61aa4",
  null
  
)

export default component.exports